/* eslint-disable no-inline-comments -- override for the entire file, makes sense to have inline here */
export enum DateFormat {
  dateTimeWithoutTimezone = "yyyy-MM-dd'T'HH:mm:ss", // 2026-01-05T10:00:00
  fullMonthDay = "MMMM d", // April 22
  shortMonthDay = "MMM d", // Jul 3
  shortMonthDayYear = "LLL d, yyyy", // Jan 1, 2022
  shortNumberMonthDayYear = "LL/dd/yyyy", // 10/10/2024
  shortWeekday = "EEE", // Thu
  time = "h:mm aaa", // 1:00 pm (Lowercase am/pm)
  weekDay = "EEEE", // Friday
  weekDayMonthDay = "EEEE, MMMM d", // Friday, March 15
  weekDayShortMonthDay = "EEEE, MMM d", // Friday, Mar 15
  weekShortDayMonthDay = "EEE, MMMM d", // Fri, March 15
  weekShortDayShortMonthDayTime = "EEE, MMM d h:mmaaa", // Mon, Oct 14 6:20pm
  year = "y", // 2024
  yearMonthDay = "y-MM-dd", // 1990-08-13
}
